export default __webpack_public_path__ + "static/media/Brass Screw Conveyor.e7ba64d0.jpg";